import { render } from "./brand_disable.vue?vue&type=template&id=0f6f3231"
import script from "./brand_disable.vue?vue&type=script&lang=js"
export * from "./brand_disable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__